<template>
  <v-layout row>
    <v-flex md12>
      <v-container
        class="pb-1 pr-0"
      >
        <v-layout row>
          <v-flex md4>
            <GroupSelect
              label="エリア"
              :lightvalue="true"
              :group="group"
              :value="field.area"
              @input="setFieldProp({area: Number($event)})"
            />
          </v-flex>
          <v-flex
            style="text-align:right"
            align-start
          >
            <BlackBtn
              :to="{ name: '顧客登録' }"
            >
              <v-icon left>
                mdi-account-plus
              </v-icon>
              顧客登録
            </BlackBtn>
            <BlackBtn
              v-if="user.roleId === 4"
              class="ml-1"
              @click="csvUploadDialogHandler('顧客CSV取込み')"
            >
              <v-icon left>
                mdi-account-multiple-plus
              </v-icon>
              顧客CSV取込み
            </BlackBtn>
            <BlackBtn
              class="ml-1"
              @click="csvUploadDialogHandler('給油CSV取込み')"
            >
              <v-icon left>
                mdi-fuel
              </v-icon>
              給油CSV取込み
            </BlackBtn>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex
            d-flex
            md7
            pa-0
            class="input-container"
          >
            <v-form
              class="d-flex"
              @submit.prevent="search"
            >
              <v-flex md4>
                <v-text-field
                  light
                  label="顧客番号"
                  :value="field.customerCode"
                  @input="setFieldProp({customerCode: $event})"
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  light
                  label="名称"
                  :value="field.name"
                  @input="setFieldProp({name: $event})"
                />
              </v-flex>
              <v-flex md4>
                <v-text-field
                  light
                  label="電話番号"
                  :value="field.tel"
                  @input="setFieldProp({tel: $event})"
                />
              </v-flex>
              <v-flex
                md2
                mr-1
                style="text-align:right"
              >
                <v-btn
                  type="submit"
                  color="success"
                >
                  検索
                </v-btn>
              </v-flex>
            </v-form>
          </v-flex>
        </v-layout>
        <csv-upload-dialog
          :visibility="csvUploadDialog"
          :dialog-text="dialogText"
          @closeDialog="csvUploadDialog=false"
        />
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { GroupSelect } from '@/components/input'
import { BlackBtn } from '@/components/ui'
import CsvUploadDialog from './CsvUploadDialog'

export default {
  components: {
    GroupSelect,
    CsvUploadDialog,
    BlackBtn
  },
  data () {
    return {
      csvUploadDialog: false,
      dialogText: ''
    }
  },
  computed: {
    ...mapState('app', ['user']),
    ...mapState('groups', ['group']),
    ...mapState('customers', ['field'])
  },
  methods: {
    ...mapMutations('customers', ['setFieldProp']),
    ...mapActions('customers', ['search']),

    csvUploadDialogHandler (text) {
      this.csvUploadDialog = true
      this.dialogText = text
    }
  }
}
</script>

<style lang="scss" scoped>

.input-container{
  flex-direction:row;
  justify-content:space-between;
}
/deep/.v-input {
  input {
    font-size: 1.1rem !important;
    color: #111 !important;
  }
  .v-label {
    color: var(--metal-grey-d) !important;
  }
}
/deep/.v-text-field__details {
  display: none !important;
}
/deep/.v-input__slot {
  margin-bottom: 0 !important;
}
</style>
